import {
  EOrderExecutionMode,
  EOrderExpiry,
  EOrderIndicate,
  EOrderState,
  EOrderType,
  IGetOrderDetailsParams
} from '@webtrader/core/api/order';
import { ETradeFillPolicy } from '@webtrader/core/api/trade';
import request from '@webtrader/core/request';

export interface IPendingOrder {
  price: number;
  comment: string;
  marginRate: number;
  openTime: number;
  orderId: string;
  stopLoss: number;
  takeProfit: number;
  volume: number;
  symbol: string;
  orderType: EOrderType;
  state: EOrderState;
  decimal: number;
  isEnable: boolean;
  currentPrice: number;
  priceTrigger: number;
  marketFillPolicy: ETradeFillPolicy[];
  fillPolicy: ETradeFillPolicy;
  tradeExpiry: EOrderExpiry;
  expiration: number;
  lotSize: number;
  lotSizeStep: number;
  units: number;
  indicate: EOrderIndicate;
  exeMode: EOrderExecutionMode;
  editable?: boolean;
  trackable?: boolean;
  closable?: boolean;
  filledLotSize: number;
  centroidDeviation?: number;
  id: number; // For Centroid Pending Order Deletion
}

export interface IGetPendingOrderDetailsParams extends IGetOrderDetailsParams {}

export default {
  getAll: (params?: { symbol?: string }, signal?: AbortSignal) =>
    request.get<IPendingOrder[]>('/api/order/v1/pending', { params, signal }),
  getDetails: (params: IGetPendingOrderDetailsParams, signal?: AbortSignal) =>
    request.get<IPendingOrder>('/api/order/v1/pending/details', { params, signal })
};
